import { mapOperator } from "./axios";

export const filterUrlGenerate = (filtros: any) => {
  const urlFilters: any = [];

  filtros.forEach((filtro: any) => {
    const operator = mapOperator(filtro.operator);

    if (filtro.operator === "between") {
      urlFilters.push(
        `filter.${filtro.field}=${operator}${filtro.value[0]},${filtro.value[1]}`,
      );
    } else if (filtro.operator === "in") {
      urlFilters.push(`filter.${filtro.field}=${operator}${filtro.value}`);
    } else {
      urlFilters.push(`filter.${filtro.field}=${operator}${filtro.value}`);
    }
  });

  return urlFilters.join("&");
};
